import React from 'react';
import { GoogleAnalyticsIcon } from '@fourthwall/icons';
const externalSourceIconsMap = {
    googleAnalytics: GoogleAnalyticsIcon,
};
const getAnalyticsExternalSourceIcon = (externalSource) => externalSource ? externalSourceIconsMap[externalSource] : undefined;
export const AnalyticsExternalSourceIcon = ({ externalSource, size = 16, }) => {
    if (!externalSource)
        return null;
    const ExternalSourceIcon = getAnalyticsExternalSourceIcon(externalSource);
    if (!ExternalSourceIcon)
        return null;
    return React.createElement(ExternalSourceIcon, { height: size, width: size });
};
